<faxe-page-layout [showAndonMenu]="false">
  <form>
    <mat-card appearance="outlined">
      <faxe-page-title></faxe-page-title>
      <faxe-select-option-chip
        label="Välj hinder"
        [dataSource]="fenceDataItems"
        [selectedByKey]="previouslySelectedFenses"
        (valueChange)="fenceChange($event)"
      >
      </faxe-select-option-chip>
      @if ( isNotEmpty(selectedFenses)) {
      <div class="border-panel">
        <h3 class="header">Välj ryttare</h3>
        <faxe-chip-list
          #riderComponent
          class="rider"
          enableInput="true"
          inputHeading="Ny ryttare..."
          [itemsSet]="riderViewDataItems"
          (itemSelectedEvent)="onRiderSelected($event)"
          (lastItemUnSelectedEvent)="onRiderLastUnSelected()"
        ></faxe-chip-list>
        <div class="rider"></div>
        @if (selectedRider) {
        <div>
          @for (fence of selectedFenses; track fence) {
          <faxe-fense-result-button
            #fenseResultButton
            [header]="fence.fenceName"
            [fenceName]="fence.fenceName"
            [preSelectedKeys]="preSelectedResultCodes"
            (repportFence)="fenceRepported($event)"
          >
          </faxe-fense-result-button>
          }
        </div>
        }
      </div>
      }
    </mat-card>

    <faxe-rolling-hist-list [listItems]="listItems"></faxe-rolling-hist-list>
  </form>
</faxe-page-layout>
